import { useMutation, useQueryClient } from "@tanstack/react-query";
import { dealApi, dealQueryKeys } from "service/crm/api/deal";
import {
  restoreDealOptions,
  setDealOptionAssociated,
} from "./dealOptionsCache";
import { contactQueryKeys } from "../api/contact";

export const useUnlinkDealMutation = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: dealApi.unlinkDealFromContact,
    onMutate: async (variables) => {
      const scopeKey = dealQueryKeys.byContact(variables.contactUuid);
      await queryClient.cancelQueries({ queryKey: scopeKey });
      return {
        snapshot: setDealOptionAssociated(
          queryClient,
          scopeKey,
          variables.dealUuid,
          false,
        ),
      };
    },
    onError: (_error, _variables, context) =>
      restoreDealOptions(queryClient, context?.snapshot),
    onSettled: (_data, _error, variables) => {
      queryClient.invalidateQueries({ queryKey: dealQueryKeys.lists() });
      queryClient.invalidateQueries({
        queryKey: dealQueryKeys.byContact(variables.contactUuid),
      });
      queryClient.invalidateQueries({
        queryKey: contactQueryKeys.activities(variables.contactUuid),
      });
    },
  });
};
